import Api from "../Utils/Axios";

export const GetFirebaseNotificationList = async (data) => {
  const response = await Api.get(
    `firebaseNotification?page=${data?.page}&limit=${data?.limit}&search=${data?.search}&phase=${data?.phase}&sortBy=${data?.sortBy || ""}&sortOrder=${data?.sortOrder || ""}`
  );
  return response.data;
};

export const DeleteFirebaseNotifications = async (data) => {
  const response = await Api.delete(`firebaseNotification/${data}`);
  return response.data;
};

export const CreateFirebaseNotification = async (data) => {
  const response = await Api.post("firebaseNotification/", data);
  return response.data;
};

export const GetSingleFirebaseNotification = async ({ id }) => {
  const response = await Api.get(`firebaseNotification/${id}`);
  return response.data;
};

export const UpdateFirebaseNotification = async (id, data) => {
  const response = await Api.put(`firebaseNotification/${id}`, data);
  return response.data;
};
